import type { Message } from '@/types'

export function getUserMessageCount(messages: Message[]): number {
  return messages.filter(message => message.role === 'user').length
}

export function getRoundNumberFromMessages(messages: Message[]): number {
  let userMessageCount = 0
  let roundNumber = 0
  // traverse the messages [chatWithNewUserMessage.messages]
  // count the number of messages that role is 'user'
  for (let i = 0; i < messages.length; i++) {
    if (messages[i].role === 'user') {
      userMessageCount++ // Count the number of 'user' messages
      roundNumber = (userMessageCount % 5 === 0) ? 5 : userMessageCount % 5
      // The above line calculates the roundNumber as described in the comments
    }
  }
  return roundNumber
}

export function getEventOrder(messages: Message[]): number {
  const userMessageCount = getUserMessageCount(messages)
  let order = Math.min(Math.ceil(userMessageCount / 5) - 1, 10)
  if (order < 0) {
    order = 0
  }
  return order
}
